import { request_fixedAssets_depreciationAmount } from 'src/api'
import { request_fixedAssets } from 'src/api/models/request_fixedAssets'
import useSWR from 'swr'
import { useNewApiClient } from './useNewApiClient'

type UseFixedAssetsOptions = {
  scope?: 'unjournalized'
  depreciationMethod?:
    | 'straight_line'
    | 'declining_balance'
    | 'petty_sum'
    | 'lump_sum'
    | 'straight_line_method'
    | 'voluntary'
}
export const useFixedAssets = (options?: UseFixedAssetsOptions) => {
  const { apiClient } = useNewApiClient()
  const { data: fixedAssets, mutate: mutateFixedAssets } = useSWR(
    `/fixed_assets?scope=${options?.scope}&depreciationMethod=${options?.depreciationMethod}`,
    async () => {
      const res = await apiClient.fixedAsset.getFixedAssets(
        options?.scope,
        options?.depreciationMethod
      )
      return res
    }
  )

  const postFixedAsset = async (fixedAssetsBasicInfo: request_fixedAssets) => {
    const res = await apiClient.fixedAsset.postFixedAssets(fixedAssetsBasicInfo)
    await mutateFixedAssets()
    return res
  }

  const patchFixedAssetsIdDepreciationAmount = async (
    id: string,
    requestBody: request_fixedAssets_depreciationAmount
  ) => {
    const res = await apiClient.fixedAsset.patchFixedAssetsIdDepreciationAmount(
      id,
      requestBody
    )
    await mutateFixedAssets()
    return res
  }
  return {
    fixedAssets,
    postFixedAsset,
    mutateFixedAssets,
    patchFixedAssetsIdDepreciationAmount
  }
}
